import React, { useEffect, useState } from "react";
import "./Cart_Products.css";
import Breadcrumb_comp from "../common-components/breadcrumb-comp/Breadcrumb_comp";
import Cart_Products_card from "./cart_Products_card/Cart_Products_card";
import May_you_like_also from "./may_you_like_also/May_you_like_also";
import Back_text_holder from "../common-components/back_text_holder/Back_text_holder";
import Stay_Connected from "../home/stay_Connected/Stay_Connected";
import { useDispatch, useSelector } from "react-redux";
import { getAllCart } from "../../features/cart/cartSlice";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { encodeId } from "../../utils/common";
import Order_summery_holder from "./may_you_like_also/order_summery_holder/Order_summery_holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingBag } from "@fortawesome/free-solid-svg-icons";
import Green_btn from "../common-components/common_btn/green_btn/Green_btn";

function Cart_Products() {
  const [searchParams] = useSearchParams();
  const productId = searchParams.get("product_id");
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    // {
    //   label: "Product",
    //   link: `/product-details/${encodeId(productId)}`,
    //   isActive: false,
    // },
    { label: "Cart Products", link: "", isActive: true },
  ];

  const isSignin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const allcartData = useSelector((state) => state.cart.allCarts);
  useEffect(() => {
    dispatch(getAllCart(isSignin));
  }, [dispatch]);

  const [instock, setInstock] = useState(false);

  const navigate = useNavigate();

  return (
    <>
      <section className="Cart_Products">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />

        {allcartData?.data?.length > 0 ? (
          <div className="row_holder">
            <div className="row justify-content-center">
              <div className="col-xxl-8 col-xl-8">
                <Cart_Products_card
                  instock={instock}
                  setInstock={setInstock}
                  data={allcartData}
                />
              </div>
              <div className="col-xxl-4 col-xl-4 col-md-6 ">
                <div className="order_summery_div">
                  <Order_summery_holder data={allcartData} />
                </div>
              </div>
            </div>
          </div>
        ) : (
          /* sober Empty Cart UI */
          <div className="empty-cart-container">
            <div className="empty-cart-icon-box">
              <FontAwesomeIcon icon={faShoppingBag} />
            </div>
            <h3 className="empty-cart-title">Your Cart is Empty</h3>
            <p className="empty-cart-description">
              Looks like you haven't added any items to your shopping cart yet.
            </p>
            <Green_btn
              btnText={"Start Shopping"}
              onClick={() => navigate("/categories")}
            />
          </div>
        )}

        <May_you_like_also instock={instock} data={allcartData} />

        {/* <Back_text_holder baseLink="/categories" backText="Product" /> */}

        {/* <Stay_Connected /> */}
      </section>
    </>
  );
}

export default Cart_Products;
